(function () {
  const STORAGE_KEY = 'thameen_runbook_v1';
  const root = document.querySelector('[data-runbook]');
  if (!root) return;

  const checkboxes = root.querySelectorAll('[data-runbook-id]');
  const progressEl = root.querySelector('[data-runbook-progress]');
  const resetBtn = root.querySelector('[data-runbook-reset]');
  const doneEl = root.querySelector('[data-runbook-done]');

  function loadState() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function saveState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function updateProgress() {
    const total = checkboxes.length;
    const done = Array.prototype.filter.call(checkboxes, cb => cb.checked).length;
    if (progressEl) {
      progressEl.textContent = done + ' of ' + total + ' complete';
    }
    if (doneEl) {
      doneEl.hidden = !(total > 0 && done === total);
    }
  }

  const state = loadState();
  checkboxes.forEach(cb => {
    const id = cb.getAttribute('data-runbook-id');
    if (state[id]) cb.checked = true;
    cb.addEventListener('change', () => {
      const current = loadState();
      if (cb.checked) current[id] = true;
      else delete current[id];
      saveState(current);
      updateProgress();
    });
  });

  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      if (!window.confirm('Clear all progress on this checklist?')) return;
      localStorage.removeItem(STORAGE_KEY);
      checkboxes.forEach(cb => { cb.checked = false; });
      updateProgress();
    });
  }

  updateProgress();
})();
